const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const parseResponse = async (response, fallbackMessage) => {
  const payload = await response.json().catch(() => null);
  if (response.ok) return payload;
  const message = payload?.detail || payload?.message || fallbackMessage || `Hata (${response.status})`;
  const error = new Error(message);
  error.status = response.status;
  error.payload = payload;
  throw error;
};

const q = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') query.set(k, String(v));
  });
  return query.toString();
};

// -----------------------------------------------------------------------
// Session durumu + tüm standart kart özetleri
// -----------------------------------------------------------------------
export async function getWorksheetStatus({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet?${q({ companyId, periodId })}`, {
    headers: buildHeaders()
  });
  return parseResponse(r, 'IFRS worksheet durumu alınamadı.');
}

// -----------------------------------------------------------------------
// Session geçişleri
// -----------------------------------------------------------------------
export async function advanceSession({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet/session/advance`, {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ companyId, periodId })
  });
  return parseResponse(r, 'VUK_READY → ADJUSTMENTS_DRAFT geçişi başarısız.');
}

export async function lockSession({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet/session/lock`, {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ companyId, periodId })
  });
  return parseResponse(r, 'Kilit işlemi başarısız. Tüm kartların hesaplanmış olduğundan emin olun.');
}

export async function unlockSession({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet/session/unlock`, {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ companyId, periodId })
  });
  return parseResponse(r, 'Kilit açma işlemi başarısız.');
}

export async function resetSession({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet/session/reset`, {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ companyId, periodId })
  });
  return parseResponse(r, 'Sıfırlama işlemi başarısız.');
}

// -----------------------------------------------------------------------
// Tek standart kartı detayı
// -----------------------------------------------------------------------
export async function getWorksheetDetail({ companyId, periodId, standardCode }) {
  const r = await fetch(
    `${API_BASE}/api/ifrs/worksheet/${standardCode}?${q({ companyId, periodId })}`,
    { headers: buildHeaders() }
  );
  return parseResponse(r, `${standardCode} kartı detayı alınamadı.`);
}

// -----------------------------------------------------------------------
// Kullanıcı giriş verilerini kaydet
// -----------------------------------------------------------------------
export async function saveWorksheetInputs({ companyId, periodId, standardCode, inputs }) {
  const r = await fetch(
    `${API_BASE}/api/ifrs/worksheet/${standardCode}?${q({ companyId, periodId })}`,
    { method: 'PUT', headers: buildHeaders(), body: JSON.stringify(inputs) }
  );
  return parseResponse(r, `${standardCode} verileri kaydedilemedi.`);
}

// -----------------------------------------------------------------------
// Tek standart hesaplama
// -----------------------------------------------------------------------
export async function computeWorksheet({ companyId, periodId, standardCode }) {
  const r = await fetch(
    `${API_BASE}/api/ifrs/worksheet/${standardCode}/compute?${q({ companyId, periodId })}`,
    { method: 'POST', headers: buildHeaders(), body: '{}' }
  );
  return parseResponse(r, `${standardCode} hesaplaması başarısız.`);
}

// -----------------------------------------------------------------------
// Tüm aktif standartları hesapla
// -----------------------------------------------------------------------
export async function computeAllWorksheets({ companyId, periodId }) {
  const r = await fetch(`${API_BASE}/api/ifrs/worksheet/compute-all`, {
    method: 'POST', headers: buildHeaders(),
    body: JSON.stringify({ companyId, periodId })
  });
  return parseResponse(r, 'Toplu hesaplama başarısız.');
}

// -----------------------------------------------------------------------
// Standart kartını aktif/pasif yap
// -----------------------------------------------------------------------
export async function toggleWorksheet({ companyId, periodId, standardCode, enabled }) {
  const r = await fetch(
    `${API_BASE}/api/ifrs/worksheet/${standardCode}/toggle?${q({ companyId, periodId, enabled })}`,
    { method: 'PATCH', headers: buildHeaders(), body: '{}' }
  );
  return parseResponse(r, `${standardCode} durumu değiştirilemedi.`);
}

// -----------------------------------------------------------------------
// VUK-IFRS ayrıntılı karşılaştırma (IFRS_READY session gerektirir)
// -----------------------------------------------------------------------
export async function getDetailedComparison({ companyId, periodId }) {
  const r = await fetch(
    `${API_BASE}/api/ifrs/comparison/detailed?${q({ companyId, periodId })}`,
    { headers: buildHeaders() }
  );
  return parseResponse(r, 'VUK-IFRS karşılaştırması alınamadı.');
}
